enum ReservationPaymentUnitEnum {
  item,
  day,
  dinner
}

export default ReservationPaymentUnitEnum;
